module.exports = __webpack_public_path__ + "img/19_8.305493cb.png";